import TextFields from "components/web/UI/TextFields";
import styled from "styled-components";
import ButtonUtil from "../UI/ButtonUtil";
import { Fragment, useEffect, useRef, useState } from "react";
import SelectBox from "components/web/UI/SelectBox";
import { alert, modalConfirm } from "components/web/cmmn/CmmnConfirm";
import { callApi } from "util/HttpService";
import CmmnRadio from "components/web/cmmn/CmmnRadioBox";

const ListInputWrap = styled.ul`
    border-top: 2px solid #EF2929;
    min-height: 100vh;
    .basic-input {
        padding: 10px;
        font-size: 16px;
        color: #3b3b3b;
        border: 1px solid #D3D3D3;
        border-radius: 4px;
        height: 35px;
    }
    &:focus {
        border-color: #FFA500 !important;
    }
    .frame-input {
        div {
            width: 50% !important;
            input {
                width: 100% !important;
            }
        }
        select {
            width: 50% !important;
        }
    }
`;
const InputTitle = styled.div`
    height: 54px;
    padding: 15px 20px;
    background-color: #F3F3F3;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    h2 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
    }
    &.modal-title {
        margin-bottom: 10px;
        background-color: #fff;
        padding: 15px 20px 0px 0px;
        h2 {
            font-size: 17px;
            font-weight: 600;
        }
    }
`;
const InputContent = styled.div`
    background-color: #fff;
    padding: 10px 20px 10px 20px;
    & > div {
        margin-bottom: 10px;
    }
    h3 {
        font-size: 20px;
        color: #3b3b3b;
        font-weight: 500;
        margin-right: 10px;
    }
    h2 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
        width: 50%;
    }
    h5 {
        margin-left: 7px;
    }
    input[type="text"]:focus {
        border-color: #FFA500;
    }
`;
const BtnWrap = styled.div`
    width: 100%;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn {
        width: 32%;
    }
`;
const BasePhotoCnt = styled.div`
    margin-bottom: ${(props) => props.$errors ? "2px !important" : "10px"};
    h2 {
        width: 100%;
    }
    p {
        font-size: 13px;
        color: rgb(255, 107, 107);
    }
    label {
        width: 100%;
    }
`;
const ErrorMsg = styled.div`
    width: 100%;
    display: flex;
    p {
        color: #ef2929;
        font-size: 13px;
    }
    div { width: 50%; }
`;
export default function MbProgramConfig({
    t,
    brchClsfCd,
    systemMode,
    onHide,
    kiskInfo,
    data,
    getKiskInfo,
    setErrors,
    errors
}) {

    const [timeLimitSettings, setTimeLimitSettings] = useState({});
    const [printMarginSettings, setPrintMarginSettings] = useState({});
    const [framePaymentCntSettings, setFramePaymentCntSettings] = useState([]);
    const [filteredFrameArr, setFilteredFrameArr] = useState([]);
    const [paymentMethodSettings, setPaymentMethodSettings] = useState([]);
    const basePhotoCntRefs = useRef({})

    useEffect(() => {
        if (kiskInfo && kiskInfo.eltmLmtnStupCn && kiskInfo.prntMrgnStupCn) {
            setTimeLimitSettings(kiskInfo.eltmLmtnStupCn);
            setPrintMarginSettings(kiskInfo.prntMrgnStupCn);
            setPaymentMethodSettings(kiskInfo.stlmMnsStupCn);
        }
    }, [kiskInfo]);

    // 기본 제한 시간, 결제 대기 시간
    const basicLimitArray = Array.from({ length: 60 }, (_, i) => ({
        key: (i + 1) * 10,
        value: (i + 1) * 10,
    }));
    // 촬영 준비 시간
    const takeReadyLimitArray = Array.from({ length: 60 }, (_, i) => ({
        key: i + 1,
        value: i + 1,
    }));
    // 촬영 시간
    const takeLimitArray = Array.from({ length: 11 }, (_, i) => ({
        key: i + 1,
        value: i + 1,
    }));
    const frameTagArray = [
        { key: "HOT", value: "hot" },
        { key: "RECOMMEND", value: "recommend" },
    ];
    // 기본 통화
    const defaultCurrencyArray = [
        { key: "₩", value: "krw" },
        { key: "¥", value: "jpy" },
        { key: "$", value: "usd" },
        { key: "A$", value: "aud" },
    ];
    // 통화 기호 유형
    const currencyTypeArray = [
        { key: t("paymentMethodSetting.bill"), value: "paper" },
        { key: t("paymentMethodSetting.coin"), value: "coin" },
    ];
    // 촬영 소리 선택
    const photoTakeSoundArray = [
        { key: 'default', value: 'default' },
        { key: 'sound1', value: 'sound1' },
        { key: 'sound2', value: 'sound2' },
    ];

    // 원본 사진 기본 선택 여부
    const lblOrgImgDefaultSelectYnArray = [
        { key: t("paymentMethodSetting.lblOrgImgDefaultSelectY"), value: 'Y'},
        { key: t("paymentMethodSetting.lblOrgImgDefaultSelectN"), value: 'N'},
    ];

    // 카드 결제 선택여부
    const cardYnArray = [
        { key:'ON', value:'true' },
        { key:'OFF', value:'false' },
    ];

    // QR 결제 선택여부
    const qrYnArray = [
        { key:'ON', value:'t'},
        { key:'OFF', value:'f'}
    ];


    const handleTimeLimitChange = (e, key) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setTimeLimitSettings(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const handlePringMarginChange = (e, key) => {
        const value = e.target.value;
        if (/^-?\d*$/.test(value)) {
            setPrintMarginSettings((prev) => ({
              ...prev,
              [key]: value
            }));
          }        
    };

    const handleFrameSettingsChange = (e, frameCd) => {
        const { name, value } = e.target;

        const numericFields = ["basePhotoCnt", "amtVal", "addAmtVal", "discntAmtVal", "takePhotoCnt"];
        const finalValue = numericFields.includes(name)
            ? value === "" ? "" : Number(value)
            : value;

        setFilteredFrameArr(prevState => {
            const newState = prevState.map(frame => {
                if (frame.frameCd === frameCd) {
                    return { ...frame, [name]: finalValue };
                }
                return frame;
            });
            return newState;
        });

        if (name === "basePhotoCnt") {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[frameCd];
                return newErrors;
            });
        }
    };

    const handlePaymentMethodChange = (method, field, value) => {
        setPaymentMethodSettings(prev =>
            prev.map(item =>
                item.method === method
                    ? {
                        ...item,
                        options: {
                            ...item.options,
                            [field]: value
                        }
                    }
                    : item
            )
        )
    };

    const handleCmmnBtnClick = async (btnNm) => {
        // timeLimitSettings, printMarginSettings, framePaymentCntSettings, paymentMethodParams 각각 호출
        switch (btnNm) {
            case "cmmnInsertBtn":
                try {
                    // bashPhotoCnt가 짝수일 때 리턴
                    // console.log(filteredFrameArr);
                    const errorMap = {};
                    filteredFrameArr.forEach(frame => {
                        if (frame?.frameInfo?.cutYn === 'Y') {
                            const value = parseInt(frame.basePhotoCnt);
                            if (value % 2 !== 0) {
                                errorMap[frame.frameCd] = t("prgmFrameSetting.errorEvenNumber");
                            }
                        }
                    });

                    if (Object.keys(errorMap).length > 0) {
                        setErrors(errorMap);
                        const firstErrorKey = Object.keys(errorMap)[0];
                        const el = basePhotoCntRefs.current[firstErrorKey];

                        if (el && el.scrollIntoView) {
                            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            el.focus?.();
                        }
                        return;
                    } else {
                        setErrors({});
                    }

                    const commonParams = { brchId: data.brchId, eqmtId: data.eqmtId, eqmtNo: data.eqmtNo, delYn: 'N' };

                    // timeLimitSettings
                    const timeLimitParams = { ...commonParams, eltmLmtnStupCn: timeLimitSettings };
                    await callApi("POST", timeLimitParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 timeLimitSettings : ", timeLimitParams);

                    // printMarginSettings
                    const printMarginParams = { ...commonParams, prntMrgnStupCn: printMarginSettings };
                    await callApi("POST", printMarginParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 printMarginSettings : ", printMarginParams);

                    // framePaymentCntSettings
                    const updatedFramePaymentCntSettings = framePaymentCntSettings.map(payment => {
                        const updatedFrame = filteredFrameArr.find(frame => frame.frameCd === payment.frameCd);
                        return updatedFrame ? { ...payment, ...updatedFrame } : payment;
                    });
                    const framePaymentParams = { ...commonParams, frmeStlmCn: updatedFramePaymentCntSettings };
                    await callApi("POST", framePaymentParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 framePaymentCntSettings : ", framePaymentParams);

                    // paymentMethodSettings
                    const paymentMethodParams = { ...commonParams, stlmMnsStupCn: paymentMethodSettings };
                    await callApi("POST", paymentMethodParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 paymentMethodParams : ", paymentMethodParams);

                    alert("", t("alert.save"), () => { getKiskInfo() });

                } catch (error) {
                    console.log(error);
                    alert("", t("alert.saveError"), () => { return });
                }
                break;
            case "cmmnResetBtn":
                try {
                    modalConfirm("", t("alert.resetConfirm"), () => {
                        setTimeLimitSettings(kiskInfo.eltmLmtnStupCn);
                        setPrintMarginSettings(kiskInfo.prntMrgnStupCn);
                        fetchData();
                        alert("", t("alert.initSuccessAlert"), () => { });
                    })
                } catch (error) {
                    console.log(error);
                    alert("", t("alert.initFailAlert"), () => { });
                }
                break;
            default: break;
        };
    };

    const fetchData = async () => {
        if (kiskInfo && kiskInfo.frmeStupCn && kiskInfo.frmeStlmCn) {
            const frameSettings = kiskInfo.frmeStupCn;
            const tmpFramePaymentCntSettings = kiskInfo.frmeStlmCn;
            setFramePaymentCntSettings(tmpFramePaymentCntSettings);

            const filteredFrames = frameSettings.filter(frame =>
                Array.isArray(frame.systemModeArr)
                && frame.systemModeArr.includes(systemMode.value)
            );

            // framePaymentCntSettings에서 filteredFrames의 frameCd가 있는 항목만 추출하여 filteredFrames에 추가
            const frameCdSet = new Set(filteredFrames.map(frame => frame.frameCd));
            const filteredPaymentSettings = tmpFramePaymentCntSettings.filter(payment => frameCdSet.has(payment.frameCd));
            // console.log("filteredPaymentSettings : ", filteredPaymentSettings);

            // filteredFrames에 amtVal 등의 정보 추가
            const mergedFrames = await Promise.all(filteredFrames.map(async frame => {
                const paymentInfo = filteredPaymentSettings.find(payment => payment.frameCd === frame.frameCd);
                return { ...frame, ...paymentInfo };
            }));

            // console.log("mergedFrames : ", mergedFrames);
            const finalFrames = mergedFrames.flat();
            // console.log("finalFrames : ", finalFrames);
            setFilteredFrameArr(finalFrames);
        }
    };

    useEffect(() => {
        fetchData();
    }, [kiskInfo]);

    // useEffect(() => {
    //     console.log("filteredFrameArr : ", filteredFrameArr);
    //     console.log("kiskInfo.prntMrgnStupCn : ", kiskInfo.prntMrgnStupCn);
    // }, [filteredFrameArr, kiskInfo]);

    const cashPayment = Array.isArray(paymentMethodSettings)
        ? paymentMethodSettings.find(p => p.method === 'cash')
        : null;

    const basePayment = Array.isArray(paymentMethodSettings)
        ? paymentMethodSettings.find(p => p.method === 'base')
        : null;

    const getPaymentMethodOptions = (method) => {
        if (!Array.isArray(paymentMethodSettings)) return {};

        const option = paymentMethodSettings.find(pm => pm.method === method)?.options;

        if (!option) {
            if (method === 'cash') return { currencyType: 'coin', cashUseMinAmount: '' };
            if (method === 'base') return { defaultCurrency: 'jpy', orgImgDownAmtVal: 100 };
        }

        return option;
    };

    return (
        <>
            <ListInputWrap>
                <li>
                    <InputTitle className="modal-title">
                        <h2>1. {t("prgmLimitTimeSetting.title")}</h2>
                    </InputTitle>
                    <InputTitle>
                        <h2>{t("prgmLimitTimeSetting.lblDefLimitTimeSet")}</h2>
                    </InputTitle>
                    <InputContent>
                        <div className="dp-flex align-cen w-100">
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={basicLimitArray}
                                onSelectChange={(e) => handleTimeLimitChange(e, 'basicLimit')}
                                tagName="basicLimit"
                                defaultVal={timeLimitSettings.basicLimit || 60}
                            />
                            <h5>{t("common.seconds")}</h5>
                        </div>
                    </InputContent>
                </li>
                <li>
                    <InputTitle>
                        <h2>{t("prgmLimitTimeSetting.lblPaymentLimitTimeSet")}</h2>
                    </InputTitle>
                    <InputContent>
                        <div className="dp-flex align-cen w-100">
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={basicLimitArray}
                                onSelectChange={(e) => handleTimeLimitChange(e, 'paymentLimit')}
                                tagName="paymentLimit"
                                defaultVal={timeLimitSettings.paymentLimit || 60}
                            />
                            <h5>{t("common.seconds")}</h5>
                        </div>
                    </InputContent>
                </li>
                <li>
                    <InputTitle>
                        <h2>{t("prgmLimitTimeSetting.lblTakeReadyLimitTimeSet")}</h2>
                    </InputTitle>
                    <InputContent>
                        <div className="dp-flex align-cen w-100">
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={takeReadyLimitArray}
                                onSelectChange={(e) => handleTimeLimitChange(e, 'takeReadyLimit')}
                                tagName="takeReadyLimit"
                                defaultVal={timeLimitSettings.takeReadyLimit || 60}
                            />
                            <h5>{t("common.seconds")}</h5>
                        </div>
                    </InputContent>
                </li>
                <li>
                    <InputTitle>
                        <h2>{t("prgmLimitTimeSetting.lblTakePhotoLimitTimeSet")}</h2>
                    </InputTitle>
                    <InputContent>
                        <div className="dp-flex align-cen w-100">
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={takeLimitArray}
                                onSelectChange={(e) => handleTimeLimitChange(e, 'takeLimit')}
                                tagName="takeLimit"
                                defaultVal={timeLimitSettings.takeLimit || 60}
                            />
                            <h5>{t("common.seconds")}</h5>
                        </div>
                    </InputContent>
                </li>
                <li>
                    <InputTitle>
                        <h2>{t("prgmLimitTimeSetting.lblPhotoTakeSound")}</h2>
                    </InputTitle>
                    <InputContent>
                        <div className="dp-flex align-cen w-100">
                            <SelectBox
                                defaultOptTxt={t("m_common.selectLable")}
                                dataArray={photoTakeSoundArray}
                                onSelectChange={(e) => handleTimeLimitChange(e, 'photoTakeSound')}
                                tagName="photoTakeSound"
                                defaultVal={timeLimitSettings.photoTakeSound || 'sound1'}
                            />
                        </div>
                    </InputContent>
                </li>
                <li>
                    <InputTitle className="modal-title">
                        <h2>2. {t("prgmPrintWhiteSpaceSetting.title")}</h2>
                    </InputTitle>
                    <InputTitle>
                        <h2>{t("prgmPrintWhiteSpaceSetting.lblTopWs")}</h2>
                    </InputTitle>
                    <InputContent>
                        <div className="dp-flex align-cen w-100">
                            <TextFields
                                type="text"
                                inputMode="text"
                                name="hTopMargin"
                                onChangeValue={(e) => handlePringMarginChange(e, 'hTopMargin')}
                                value={printMarginSettings?.hTopMargin || ""}
                                className="w-100"
                                
                            />
                            <h5>px</h5>
                        </div>
                    </InputContent>
                </li>
                <li>
                    <InputTitle>
                        <h2>{t("prgmPrintWhiteSpaceSetting.lblLeftWs")}</h2>
                    </InputTitle>
                    <InputContent>
                        <div className="dp-flex align-cen w-100">
                            <TextFields
                                type="text"
                                inputMode="text"
                                name="hLeftMargin"
                                onChangeValue={(e) => handlePringMarginChange(e, 'hLeftMargin')}
                                value={printMarginSettings?.hLeftMargin || ""}
                                className="w-100"
                                
                            />
                            <h5>px</h5>
                        </div>
                    </InputContent>
                </li>
                {brchClsfCd === "KSC" && Array.isArray(paymentMethodSettings) && paymentMethodSettings.length > 0 && (
                    <>
                        <li>
                            <InputTitle className="modal-title">
                                <h2>3. {t("paymentMethodSetting.title")}</h2>
                            </InputTitle>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.lblCurrencyType")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <CmmnRadio
                                        tagName="currencyType"
                                        dataArray={currencyTypeArray}
                                        defaultVal={getPaymentMethodOptions("cash")?.currencyType || 'coin'}
                                        onSelectChange={(e) => handlePaymentMethodChange('cash', 'currencyType', e.target.value)}
                                    />
                                </div>
                            </InputContent>
                        </li>
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.lblCashUseMinAmount")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <TextFields
                                        type="text"
                                        name="cashUseMinAmount"
                                        value={String(getPaymentMethodOptions('cash')?.cashUseMinAmount || '')}
                                        onChangeValue={(e) => handlePaymentMethodChange('cash', 'cashUseMinAmount', e.target.value)}
                                        className="w-100"
                                    />
                                </div>
                            </InputContent>
                        </li>
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.lblDefaultCurrency")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <SelectBox
                                        defaultOptTxt={t("saleHistPage.entire")}
                                        dataArray={defaultCurrencyArray}
                                        onSelectChange={(e) => handlePaymentMethodChange('base', 'defaultCurrency', e.target.value)}
                                        tagName="defaultCurrency"
                                        defaultVal={getPaymentMethodOptions('base')?.defaultCurrency || 'jpy'}
                                    />
                                </div>
                            </InputContent>
                        </li>
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.orgPhotoDownloadPrice")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <TextFields
                                        type="number"
                                        name="orgImgDownAmtVal"
                                        value={getPaymentMethodOptions('base')?.orgImgDownAmtVal}
                                        onChangeValue={(e) => handlePaymentMethodChange('base', 'orgImgDownAmtVal', e.target.value)}
                                        className="w-100"
                                    />
                                </div>
                            </InputContent>
                        </li>
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.lblOrgImgDefaultSelectYn")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <CmmnRadio
                                        tagName="orgImgDownDefaultSelect"
                                        dataArray={lblOrgImgDefaultSelectYnArray}
                                        defaultVal={getPaymentMethodOptions("base")?.orgImgDownDefaultSelect || 'Y'}
                                        onSelectChange={(e) => handlePaymentMethodChange('base', 'orgImgDownDefaultSelect', e.target.value)}
                                    />
                                </div>
                            </InputContent>
                        </li>
                        
                        {/* 카드 결제 Y/N */}
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.cardPayment")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <CmmnRadio
                                        tagName="enabled"
                                        dataArray={cardYnArray}
                                        defaultVal={getPaymentMethodOptions("card")?.enabled === true ? 'true':'false' || 'false'}
                                        onSelectChange={(e) => handlePaymentMethodChange('card', 'enabled', e.target.value === "true" ? true:false)}
                                    />
                                </div>
                            </InputContent>
                        </li>

                        {/* KSNET 카드 단말 번호 */}
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.ksNetCardTerminalNum")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <TextFields
                                        type="text"
                                        name="ksNetCardReaderDeviceNo"
                                        value={getPaymentMethodOptions('card')?.ksNetCardReaderDeviceNo}
                                        onChangeValue={(e) => handlePaymentMethodChange('card','ksNetCardReaderDeviceNo',e.target.value)}
                                        className="w-100"
                                    />
                                </div>
                            </InputContent>
                        </li>
                        {/* KSNET 연동 포트번호 */}
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.ksNetLinkPortNum")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <TextFields
                                        type="text"
                                        name="ksNetLnkgPort"
                                        value={getPaymentMethodOptions('card')?.ksNetLnkgPort}
                                        onChangeValue={(e) => handlePaymentMethodChange('card','ksNetLnkgPort',e.target.value)}
                                        className="w-100"
                                    />
                                </div>
                            </InputContent>
                        </li>
                        {/* QR 결제 Y/N */}
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.qrPayment")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <CmmnRadio
                                        tagName="qrEnabled"
                                        dataArray={qrYnArray}
                                        defaultVal={getPaymentMethodOptions("qr")?.enabled === true ? 't':'f' || 'f'}
                                        onSelectChange={(e) => handlePaymentMethodChange('qr', 'enabled', e.target.value === "t" ? true:false)}
                                    />
                                </div>
                            </InputContent>
                        </li>
                    </>
                )}
                {brchClsfCd === "FCC" && Array.isArray(paymentMethodSettings) && paymentMethodSettings.length > 0 && (
                    <>
                        <li>
                            <InputTitle className="modal-title">
                                <h2>3. {t("paymentMethodSetting.title")}</h2>
                            </InputTitle>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.orgPhotoDownloadPrice")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <TextFields
                                        type="number"
                                        name="orgImgDownAmtVal"
                                        value={getPaymentMethodOptions('base')?.orgImgDownAmtVal}
                                        onChangeValue={(e) => handlePaymentMethodChange('base', 'orgImgDownAmtVal', e.target.value)}
                                        className="w-100"
                                    />
                                </div>
                            </InputContent>
                        </li>
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.lblOrgImgDefaultSelectYn")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <CmmnRadio
                                        tagName="orgImgDownDefaultSelect"
                                        dataArray={lblOrgImgDefaultSelectYnArray}
                                        defaultVal={getPaymentMethodOptions("base")?.orgImgDownDefaultSelect || 'Y'}
                                        onSelectChange={(e) => handlePaymentMethodChange('base', 'orgImgDownDefaultSelect', e.target.value)}
                                    />
                                </div>
                            </InputContent>
                        </li>
                        {/* QR 결제 Y/N */}
                        <li>
                            <InputTitle>
                                <h2>{t("paymentMethodSetting.qrPayment")}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen w-100">
                                    <CmmnRadio
                                        tagName="qrEnabled"
                                        dataArray={qrYnArray}
                                        defaultVal={getPaymentMethodOptions("qr")?.enabled === true ? 't':'f' || 'f'}
                                        onSelectChange={(e) => handlePaymentMethodChange('qr', 'enabled', e.target.value === "t" ? true:false)}
                                    />
                                </div>
                            </InputContent>
                        </li>
                    </>
                )}
                <li>
                    <InputTitle className="modal-title">
                        <h2>{brchClsfCd === "KSC" || brchClsfCd === "FCC"
                            ? Array.isArray(paymentMethodSettings) && paymentMethodSettings.length > 0
                                ? "4. "
                                : "3. "
                            : "3. "}
                        {t("prgmFrameSetting.title")}</h2>
                    </InputTitle>
                    {filteredFrameArr.map((frame, index) => (
                        <Fragment key={`fragment_key_${index}`}>
                            <InputTitle>
                                <h2>{t(`prgmFrameSetting.lbl${frame.frameCd}FrameExpl`)}</h2>
                            </InputTitle>
                            <InputContent>
                                <div className="dp-flex align-cen space-between w-100 frame-input">
                                    <h2>{t("prgmFrameSetting.lblBaseAmt")}</h2>
                                    <TextFields
                                        key={`inputKey_0_${index}`}
                                        type="number"
                                        name="amtVal"
                                        value={parseInt(frame.amtVal)}
                                        onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                        className="w-100"
                                        step="100"
                                        pattern="\d*"
                                    />
                                </div>
                                <div className="dp-flex align-cen space-between w-100 frame-input">
                                    <h2>{t("prgmFrameSetting.lblDisCntAmt")}</h2>
                                    <TextFields
                                        key={`inputKey_0_1_${index}`}
                                        type="number"
                                        name="discntAmtVal"
                                        value={parseInt(frame.discntAmtVal)}
                                        onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                        className="w-100"
                                        step="100"
                                        pattern="\d*"
                                    />
                                </div>
                                <div className="dp-flex align-cen space-between w-100 frame-input">
                                    <h2>{t("prgmFrameSetting.lblAddAmt")}</h2>
                                    <TextFields
                                        key={`inputKey_1_${index}`}
                                        type="number"
                                        name="addAmtVal"
                                        value={parseInt(frame.addAmtVal)}
                                        onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                        className="w-100"
                                        step="100"
                                        pattern="\d*"
                                    />
                                </div>
                                <BasePhotoCnt className="dp-flex align-cen space-between w-100 frame-input" $cutYn={frame.frameInfo.cutYn === 'Y'} $errors={!!errors?.[frame.frameCd]}>
                                    <div>
                                        <h2>{t("prgmFrameSetting.lblPrintPhotCnt")}</h2>
                                        {frame.frameInfo.cutYn === 'Y' &&
                                            <label>
                                                <p>({t("prgmFrameSetting.evenNumber")})</p>
                                            </label>
                                        }
                                    </div>
                                    <TextFields
                                        ref={(el) => (basePhotoCntRefs.current[frame.frameCd] = el)}
                                        key={`inputKey_2_${index}`}
                                        type="number"
                                        name="basePhotoCnt"
                                        value={frame.basePhotoCnt === "" || isNaN(frame.basePhotoCnt) ? "" : Number(frame.basePhotoCnt)}
                                        step={frame.frameInfo.cutYn === 'Y' ? 2 : 1}
                                        min={frame.frameInfo.cutYn === 'Y' ? 2 : 1}
                                        onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                        className="w-100"
                                        pattern="\d*"
                                    />
                                </BasePhotoCnt>
                                {frame.frameInfo.cutYn === 'Y' && errors?.[frame.frameCd] && (
                                    <ErrorMsg>
                                        <div style={{ width: "50%" }}> </div>
                                        <div style={{ width: "50%" }}><p>{errors[frame.frameCd]}</p></div>
                                    </ErrorMsg>
                                )}
                                <div className="dp-flex align-cen space-between w-100 frame-input">
                                    <h2>{t("prgmFrameSetting.lblPhotoTakeCnt")}</h2>
                                    <TextFields
                                        key={`inputKey_3_${index}`}
                                        type="number"
                                        name="takePhotoCnt"
                                        value={parseInt(frame.takePhotoCnt)}
                                        onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                        className="w-100"
                                        pattern="\d*"
                                    />
                                </div>

                                <div className="dp-flex align-cen space-between w-100 frame-input">
                                    <h2>{t("prgmFrameSetting.lblFrameTakePhotoLimitTime")}</h2>
                                    <TextFields
                                        key={`inputKey_4_${index}`}
                                        type="number"
                                        name="frameTakePhotoLimitTime"
                                        value={parseInt(frame.frameTakePhotoLimitTime)}
                                        onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                        className="w-100"
                                        pattern="\d*"
                                    />
                                </div>

                                <div className="dp-flex align-cen space-between w-100 frame-input">
                                    <h2>{t("prgmFrameSetting.lblFrameTag")}</h2>
                                    <SelectBox
                                        defaultOptTxt={t("m_common.selectLable")}
                                        dataArray={frameTagArray}
                                        onSelectChange={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                        tagName="frameTag"
                                        defaultVal={frame.frameTag || ""}
                                        disabled={frame.photoModeCd === "B"}
                                    />
                                </div>
                            </InputContent>
                        </Fragment>
                    ))}

                </li>
            </ListInputWrap>
            <BtnWrap>
                <ButtonUtil className="btn btn-danger round-filled-small-btn"
                    value={t("common.lblInitBtn")}
                    onClick={() => { handleCmmnBtnClick("cmmnResetBtn") }}
                />
                <ButtonUtil className="btn btn-outline-light round-solid-medium-btn"
                    value={t("common.cancelLable")}
                    onClick={() => { onHide() }}
                />
                <ButtonUtil className="btn btn-danger round-filled-small-btn"
                    value={t("common.saveLable")}
                    onClick={() => { handleCmmnBtnClick("cmmnInsertBtn") }}
                />
            </BtnWrap>
        </>
    )
}
